import { createContext } from 'react';

export interface UserLocationObj {
    isFallback: boolean;
    country: {
        iso_code: string;
    };
}

export default createContext<UserLocationObj | null>(null);
